module.exports = __webpack_public_path__ + "static/media/a.i.r.-partenaire-santé.2fab500f.png";